<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: item.path }" v-for="(item, index) in $route.meta" :key="index" v-if="item.path != '/store/home'">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    list () {
      return this.$route.matched
    }
  },
  created () {
    console.log(this.$route)
  },
}
</script>

<style scoped lang="stylus">
  .breadcrumb
    line-height 40px
    // background #fff
    border-radius 4px
    margin-bottom 10px
    .el-breadcrumb
      line-height  2
      padding-left 4px
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/Breadcrumb.vue